import type { MainNavRoute, MainPath } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

import { makeChildren } from '../utils';

export const ImportExportPath: MainPath = '/import_export/:section?';
export const EmailPath: MainPath = '/emails/:id?';
export const WebshopPath: MainPath = '/webshop/:id?/:section?';
export const SettingsPath: MainPath = '/settings';
export const PDFPath: MainPath = '/pdf';
export const QuickbookPath: MainPath = '/quickbooks/:id?';
export const ApiKeysPath: MainPath = '/apikeys';

export const WEBSHOPS_TABS = [
  'info',
  'messages',
  'banners',
  'app',
  'email',
  'main',
  'layout',
  'products',
  'marketing',
  'theme',
  'ifs',
  'hotel_itinerary',
  'referrals',
  'satispay',
  'widget',
  'wallet',
  'snowitcards',
] as const;

export type WebshopsTabs = (typeof WEBSHOPS_TABS)[number];

export const ImportExportRoute: MainNavRoute = {
  path: '/import_export',
  label: 'routes.import_export',
  icon: 'import_export',
  type: 1,
  permissions: [PERMISSIONS.IMPORT_EXPORT__VIEW],
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-24121/b9673b8100a5ca8',
  children: [
    {
      path: ':section',
      permissions: [PERMISSIONS.IMPORT_EXPORT__VIEW],
    },
  ],
};

export const EmailRoute: MainNavRoute = {
  path: '/emails',
  label: 'routes.emails',
  icon: 'email',
  type: 1,
  permissions: [PERMISSIONS.EMAILS__LIST],
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-24281/c271ab03ce75467',
  children: [
    {
      path: ':id',
      permissions: [PERMISSIONS.EMAILS__DETAILS],
    },
  ],
};

export const WebshopRoute: MainNavRoute = {
  path: '/webshop',
  label: 'routes.webshop',
  icon: 'tenant',
  type: 1,
  permissions: [PERMISSIONS.WEBSHOP__LIST],
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-24301/8589bff9efef242',
  children: [
    {
      path: ':id',
      permissions: [PERMISSIONS.WEBSHOP__CONFIG],
      children: makeChildren<WebshopsTabs>({
        info: { path: 'info' },
        messages: { path: 'messages' },
        app: { path: 'app' },
        email: { path: 'email' },
        main: { path: 'main' },
        layout: { path: 'layout' },
        products: { path: 'products' },
        marketing: { path: 'marketing' },
        theme: { path: 'theme' },
        ifs: { path: 'ifs' },
        hotel_itinerary: { path: 'hotel_itinerary' },
        referrals: { path: 'referrals' },
        satispay: { path: 'satispay' },
        widget: { path: 'widget' },
        banners: { path: 'banners' },
        wallet: { path: 'wallet' },
        snowitcards: { path: 'snowitcards' },
      }),
    },
  ],
};

export const QuickbooksRoute: MainNavRoute = {
  path: '/quickbooks',
  label: 'routes.quickbooks',
  icon: 'money',
  type: 0,
  children: [{ path: ':id' }],
};

export const SettingsRoute: MainNavRoute = {
  path: '/settings',
  label: 'routes.settings',
  type: 1,
  hidden: true,
};

export const PDFRoute: MainNavRoute = {
  path: '/pdf',
  label: 'routes.pdf',
  type: 1,
  hidden: true,
};

export const ApiKeysRoute: MainNavRoute = {
  path: '/apikeys',
  label: 'routes.apikeys',
  icon: 'key',
  type: 0,
};
